// extracted by mini-css-extract-plugin
module.exports = {"approvalContainer":"EditApprovalContainer_approvalContainer__1Qg99","header":"EditApprovalContainer_header__1U3z1"};